import { Box, Alert, MenuItem } from '@mui/material';
import { CustomTextField, CustomAutoComplete, CustomCheckbox, VerticalForm } from '../../../common/components';

const GeneralDataSection = ({ formData, errors, onChange, isEditing }) => {
  return (
    <VerticalForm>
      <CustomTextField
        label="Descripción"
        value={formData.description}
        onChange={(e) => onChange('description', e.target.value)}
        error={Boolean(errors.description)}
        helperText={errors.description}
        placeholder="Ingrese la descripción del tipo de movimiento"
        required
        inputProps={{ maxLength: 100 }}
        fullWidth
        size="medium"
      />

      <CustomAutoComplete
        label="Naturaleza"
        name="nature"
        value={formData.nature}
        onChange={(e) => onChange('nature', e.target.value)}
        error={Boolean(errors.nature)}
        helperText={errors.nature}
        required
        fullWidth
        size="medium"
      >
        <MenuItem value="debit">Débito</MenuItem>
        <MenuItem value="credit">Crédito</MenuItem>
      </CustomAutoComplete>

      <CustomCheckbox
        label="Disponible para órdenes de pago"
        checked={Boolean(formData.display_in_orders)}
        onChange={(e) => onChange('display_in_orders', e.target.checked)}
        sx={{ mt: 1 }}
      />

      <CustomCheckbox
        label="Válido para movimientos bancarios"
        checked={Boolean(formData.is_bank_movement_type)}
        onChange={(e) => onChange('is_bank_movement_type', e.target.checked)}
        sx={{ mt: 1 }}
      />

      <Box sx={{ mt: 2 }}>
        <Alert severity="info">
          <strong>Información:</strong>
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>
              <strong>Débito:</strong> Representa salidas de dinero (pagos, gastos, etc.)
            </li>
            <li>
              <strong>Crédito:</strong> Representa entradas de dinero (ingresos, cobros, etc.)
            </li>
          </ul>
        </Alert>
      </Box>
    </VerticalForm>
  );
};

export default GeneralDataSection;
